<app-loader></app-loader>
<div class="custom-note">
    <form [formGroup]="driverNotesForm" (ngSubmit)="addDriverNotesHistory()">
        <div class="note">
            <div class="write-note-to-william-henry">
                <div class="close-icon" (click)="closeDialog()">
                    <img src="../../../../../assets/images/close-icon-model.svg" alt="Close" />
                </div>
                <div class="border-bottom">
                    <span class="write-note-to-william-henry-span">Write Note for </span>
                    <span class="write-note-to-william-henry-span2">{{driverName}}</span>
                </div>
            </div>
            <div class="textarea-outer">
                <textarea id="note" rows="5" cols="30" maxlength="512" pInputTextarea placeholder="Type here to write"
                    formControlName="note"></textarea>
                <div
                    *ngIf="driverNotesForm.controls['note'].hasError('required') && driverNotesForm.controls['note'].touched">
                    <div class="validation-error">Note is required.</div>
                </div>
            </div>
            <div class="max-outer">
                <div class="set-pickup-point">Maximum characters - 512</div>
                <div class="save-btn-outer">
                    <p-button type="submit" label="Save" [disabled]="driverNotesForm.invalid"></p-button>
                </div>
            </div>
        </div>
    </form>
</div>